(ns manatee.qa.view.compare-item-group
  "A comparison summary view of the items in an item group completed by two
   annotators."
  (:require [manatee.admin.task-config.subs :as task-config-subs]
            [manatee.annotation.components :as annotation-components]
            [manatee.components.table.formatters :as manatee-formatters]
            [manatee.edit.subs :as edit.subs]
            [manatee.edit.view :refer [date-field]]
            [manatee.qa.subs :as qa.subs]
            [manatee.qa.view.shared :as view-shared]
            [manatee.ui.templates :as templates]
            [manatee.user.components :as user-components]
            [re-frame.core :as rf]
            [rothko.collection-components.core :as collection]
            [rothko.collection-components.table.component :as table]
            [rothko.icon-animated.component :refer [spinner]]
            [rothko.layout.component :refer [layout]]
            [rothko.panel.component :refer [panel]]))

(defn- item-groups->edit-summary
  [item-group-a item-group-b]
  (map (fn [answer-item-a answer-item-b]
         (let [edit-a (first (:edits answer-item-a))
               edit-b (first (:edits answer-item-b))]
           {:id        (:id answer-item-a)
            :created-a (:created edit-a)
            :created-b (:created edit-b)
            :status-a  (:status edit-a)
            :status-b  (:status edit-b)}))
       (:answer-items item-group-a)
       (:answer-items item-group-b)))

(defn item-group-user-name-component
  [item-group title]
  (let [edit (first (get-in item-group [:part-item :edits]))]
    (:user edit)
    [panel {:appearance #{:simple}}
     [:div
      [:h5 title]
      [:span [:strong "Annotator: "] [user-components/full-name (:user edit)]]]]))

(defn- component
  [task-config user-a-item-group user-b-item-group user-a user-b]
  [:<>
   [:h4 "Compare Item Group"]
   [:div
    [layout {:appearance #{:qa-view-details}}
     [view-shared/item-details task-config (dissoc (:part-item user-a-item-group)
                                                   :score)
      {:compact? true}]
     [item-group-user-name-component user-a-item-group "Edit A Details"]
     [item-group-user-name-component user-b-item-group "Edit B Details"]]
    [:br]
    [table/component
     {:appearance        #{:primary :qa-compare-table}
      ::collection/items  (item-groups->edit-summary user-a-item-group user-b-item-group)
      ::collection/fields [{::collection/label "Item"
                            ::table/formatter  (fn [_ {:keys [id]
                                                       :as   _answer-item}]
                                                 [manatee-formatters/id-field
                                                  {:id   id
                                                   :path [:manatee.qa.handlers/compare-item-edits :item-id id :user-a user-a :user-b user-b]}])}
                           {::collection/id    :created-a
                            ::table/ordered?   true
                            ::collection/label "Created A"
                            ::table/formatter  (date-field :created-a)}
                           {::collection/id    :created-b
                            ::table/ordered?   true
                            ::collection/label "Created B"
                            ::table/formatter  (date-field :created-b)}
                           {::collection/id    :status-a
                            ::collection/label "Status A"}
                           {::collection/id    :status-b
                            ::collection/label "Status B"}]}]]])

(defn- component-loading-wrapper
  [loading-text component]
  (let [qa-loading @(rf/subscribe [::qa.subs/qa-loading])]
    [:div.qa-view-container
     [annotation-components/alert-container]
     [panel {:appearance #{:primary}}
      (if qa-loading
        [:div
         [:h4 loading-text]
         [spinner {:size 20}]]
        component)]]))

(defn- container
  []
  (let [{user-a-item-group :user-a
         user-b-item-group :user-b} @(rf/subscribe [::qa.subs/comparate-item-groups])
        {:keys [user-a user-b]
         :as _compare-options}      @(rf/subscribe [::edit.subs/compare-options])

        part-item (:part-item user-a-item-group)
        task-config @(rf/subscribe [::task-config-subs/task-config (get-in part-item [:task-config-id])])]
    (component-loading-wrapper "Loading item groups ..."
                               [component task-config user-a-item-group user-b-item-group user-a user-b])))

(def page
  {:template templates/single-column
   :main     container})
